import { useTranslation } from "react-i18next";

type Section = {
	heading: string;
	paragraphs: string[];
};

export default function PrivacyPolicy() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`marketing.privacy.${key}`);

	const sections = t("marketing.privacy.sections", { returnObjects: true }) as Section[];

	return (
		<div className="w-full flex flex-col items-center font-urbanist">
			<section className="w-full px-4 md:px-16">
				<div className="max-w-[900px] mx-auto py-16 sm:py-24 flex flex-col gap-10">
					<div className="flex flex-col gap-3">
						<h1 className="text-[36px] md:text-[48px] font-bold leading-[120%] text-[#1D243C]">
							{ts("title")}
						</h1>
						<p className="text-[14px] text-[#8A8AA0]">{ts("lastUpdated")}</p>
						<p className="text-[18px] leading-[150%] text-[#626373] mt-2">{ts("intro")}</p>
					</div>

					<div className="flex flex-col gap-10">
						{sections?.map((section) => (
							<div key={section.heading} className="flex flex-col gap-3">
								<h2 className="text-[22px] md:text-[26px] font-bold leading-[130%] text-[#1D243C]">
									{section.heading}
								</h2>
								{section.paragraphs?.map((paragraph, index) => (
									<p
										key={`${section.heading}-${index}`}
										className="text-[16px] leading-[160%] text-[#626373] whitespace-pre-line"
									>
										{paragraph}
									</p>
								))}
							</div>
						))}
					</div>
				</div>
			</section>
		</div>
	);
}
